<div class="class-reg-popup">
  <div class="text-center succsess-register-box">
    <!-- <img src="assets/img/success-icon.gif" class="card-icon" alt=""> -->
    <img src="assets/img/success-icon.svg" class="card-icon" alt="">
    <h4>You have been registered for <br><span>'{{data.title}}'</span></h4>
    <p class="my-data-note">We have sent you a confirmation on your registered mobile number</p>
    <!-- <p class="my-2"></p> -->
    <button class="_btn _btn-info UNFAPP-blue-txt-link mb-0" type="button" data-dismiss="modal" (click)="closeDialog()">CLOSE</button>
  </div>
</div>